export class EoQueryDataModel {
  DAYS_BEFORE_AFTER_EO_ACCOMPLISHED: number;
  CYC_BEFORE_AFTER_EO_ACCOMPLISHED: number;
  HRS_BEFORE_AFTER_EO_ACCOMPLISHED: number;
  MOD_HISTORY_DISCREPANCY_UID: string;
  DSCRP_NBR: string;
  ACN: string;
  FLEET_CD: string;
  ACN_MODEL: string;
  ACN_STATUS: string;
  ACN_TSN: number;
  ACN_CSN: number;
  ACN_DSN: number;
  ACN_EQUIP_TYPE: string;
  ACN_PREV_OWNER: string;
  FX_SERVICE_HRS: number;
  FX_SERVICE_CYC: number;
  ETOPS_FLAG: string;
  ETOPS_MAX_MINUTES: number;
  AC_ENGINE_MFG: string;
  MORNINGSTAR_IND: string;
  C_CHECK_PLAN_DT: Date;
  ORIGINAL_ATA: string;
  ORIGINAL_ATA_CHAPTER: string;
  REPORTING_ATA: string;
  REPORTING_ATA_CHAPTER: string;
  RECODED_MALFUNCTION_CD: string;
  RECODED_MALFUNCTION_CD_DESC: string;
  RECODED_FIX_CD: string;
  RECODED_FIX_CD_DESC: string;
  MOD_NBR: string;
  MOD_REV: string;
  REV_COMPLD_WITH: string;
  NUMBER_OF_PARTS_ACCOMPLISHED: number;
  ACCOMPLISHED_PARTS: string;
  ACCOMPLISHMENT_STATION: string;
  TWO_YEAR_INTERVAL_IND: string;
  YEAR_INTERVAL_IND: string;
  DAY_SPEC: string;
  CYC_SPEC: string;
  HRS_SPEC: string;
  MAX_ACCOMPLISH_DATE: Date;
  DSCRP_OPEN_DTM: Date;
  AC_TOTAL_CYCLES_OPEN_DT: number;
  AC_TOTAL_HRS_OPEN_DT: number;
  DISCREPANCY_TEXT: string;
  EXTENDED_CORRECTIVE_ACTION: string;
  CPNS_REMOVED: string;
  PRE_DISCREPANCY_IND: number;
  POST_DISCREPANCY_IND: number;
  PRE_M2_IND: number;
  POST_M2_IND: number;
  PRE_DELAY_MIN: number;
  POST_DELAY_MIN: number;
  PRE_SIGEVENT_IND: number;
  POST_SIGEVENT_IND: number;
  PRE_OOS_EVENT_HRS: number;
  POST_OOS_EVENT_HRS: number;
  PRE_OOS_EVENT_CNT: number;
  POST_OOS_EVENT_CNT: number;
  PRE_WDL_PACKAGE_CNT: number;
  POST_WDL_PACKAGE_CNT: number;
  PRE_RDL_PACKAGE_CNT: number;
  POST_RDL_PACKAGE_CNT: number;
  PRE_PDIS_COST: number;
  POST_PDIS_COST: number;
  PRE_DELAY_COST: number;
  POST_DELAY_COST: number;
  PRE_SIGEVENT_COST: number;
  POST_SIGEVENT_COST: number;
  PRE_DIRECT_OOS_EVENT_COST: number;
  POST_DIRECT_OOS_EVENT_COST: number;
  PRE_INDIRECT_OOS_EVENT_COST: number;
  POST_INDIRECT_OOS_EVENT_COST: number;
  PRE_TOTAL_OOS_EVENT_COST: number;
  POST_TOTAL_OOS_EVENT_COST: number;
  PRE_WDL_COST: number;
  POST_WDL_COST: number;
  PRE_RDL_COST: number;
  POST_RDL_COST: number;
  PRE_PAIN_COST: number;
  POST_PAIN_COST: number;
  UNSUCCESSFUL_IND: number;
  REV_DEPTS: number;
}
